var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.406 12.75a.83.83 0 0 0 1.156 0l9.188-9.187a.83.83 0 0 0 0-1.156l-1.125-1.125a.79.79 0 0 0-1.125 0L7 8.781l-3.531-3.5a.79.79 0 0 0-1.125 0L1.219 6.406a.83.83 0 0 0 0 1.156l5.188 5.188z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.2ac0316fe3160be972c1c577dc0f6eec.svg";
export { ForwardRef as ReactComponent };